import {
  convertDateToYYYYMMDDFormat,
  CustomDateRangePicker,
  getFirstDayOfMonth,
  getToday,
  NoDataComponent,
  PageWrapper,
  SimpleTableLoadingSkeleton,
  STATUSPAGE,
  SUBMIT_BUTTON,
  TableVirtualized,
} from '@repo/ui';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useStudentsNoAppUsage } from 'presentation/app/modules/Reports/hooks/useStudentsNoAppUsage';
import { Card, Col, Label, Row, Spinner } from 'reactstrap';

import { makeStudentsNoAppUsageColumns } from '../../../common/columns/students/students-no-app-usage-columns';

export const StudentsNoAppUsage = () => {
  const {
    loading,
    validation,
    hasFetchedData,
    selectedSubmitBtnRef,
    studentsNoAppUsageListData,
    getLegends,
  } = useStudentsNoAppUsage();

  return (
    <PageWrapper
      title={`${getLegends('ESTUDANTE', true)} sem Utilização do App`}
    >
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>{`${getLegends('ESTUDANTE', true)} sem Utilização do App`}</h4>
      </Col>
      <Card>
        <ReportsGeneralFilters
          buttonsChildren={
            <div className="w-100 d-flex justify-content-end gap-2">
              <button
                id="search-button-json"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.JSON;
                }}
                className="btn btn-primary waves-effect waves-light"
                disabled={
                  Boolean(loading.loadingButtons) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON &&
                Boolean(loading.loadingButtons) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </button>
              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.PDF;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  Boolean(loading.loadingButtons) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF &&
                Boolean(loading.loadingButtons) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>
              <button
                id="export-excel"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.EXCEL;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  Boolean(loading.loadingButtons) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL &&
                Boolean(loading.loadingButtons) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
          validation={validation}
          inputsChildren={
            <>
              <Col sm={12} md={6} lg={4} className="mb-3">
                <Row>
                  <Label htmlFor="initial-date" className="form-label">
                    Período
                  </Label>
                  <CustomDateRangePicker
                    initialStartDate={getFirstDayOfMonth()}
                    initialEndDate={getToday()}
                    placement="auto"
                    onDateChange={(start, ends) => {
                      validation.setFieldValue(
                        'starts',
                        convertDateToYYYYMMDDFormat(start),
                      );
                      validation.setFieldValue(
                        'ends',
                        convertDateToYYYYMMDDFormat(ends),
                      );
                    }}
                  />
                </Row>
              </Col>
            </>
          }
        />
        {studentsNoAppUsageListData?.length === 0 &&
          hasFetchedData &&
          loading.loadingTable === STATUSPAGE.DONE && (
            <div className="p-4">
              <NoDataComponent />
            </div>
          )}

        {loading.loadingTable === STATUSPAGE.LOADING && (
          <SimpleTableLoadingSkeleton />
        )}

        {loading.loadingTable === STATUSPAGE.DONE &&
          studentsNoAppUsageListData?.length > 0 && (
            <TableVirtualized
              columns={makeStudentsNoAppUsageColumns()}
              data={studentsNoAppUsageListData}
            />
          )}
      </Card>
    </PageWrapper>
  );
};
